// Section 17: priority group 'Elders'. Members are listed in sorted id order; the rationing
// phase ranks groups by the policy's order and breaks ties by lowest strength first.
import { definePriorityGroup } from '../../core/registry';
import { isElder, peopleSorted } from '../../core/queries';
import type { Config } from '../../config';

export function elders(_config: Config) {
  return definePriorityGroup({
    id: 'elders',
    label: 'Elders',
    section: 'S17',
    members: (ctx) =>
      peopleSorted(ctx.state)
        .filter((p) => isElder(ctx.cfg, p))
        .map((p) => p.id),
  });
}
